var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.clone
    ? _c("div", { staticClass: "update-detail" }, [
        _c("div", { staticClass: "section" }, [
          _c("h3", [
            _vm._v(
              _vm._s(_vm.$t("message.channelSettings") || "Kanal Ayarları")
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("whatsappChannel.channelName"))),
              ]),
              _vm._v(" "),
              _c("a-input", {
                attrs: { placeholder: _vm.$t("whatsappChannel.channelName") },
                model: {
                  value: _vm.clone.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "name", $$v)
                  },
                  expression: "clone.name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", [
                _vm._v(
                  _vm._s(_vm.$t("message.apiKeyMode") || "API Anahtarı Modu")
                ),
              ]),
              _vm._v(" "),
              _c(
                "a-radio-group",
                {
                  staticClass: "key-mode-group",
                  model: {
                    value: _vm.clone.payload.keyMode,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone.payload, "keyMode", $$v)
                    },
                    expression: "clone.payload.keyMode",
                  },
                },
                [
                  _c(
                    "a-radio",
                    {
                      staticClass: "key-mode-option",
                      attrs: { value: "byok" },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("message.byokTitle") ||
                              "Kendi API Anahtarımı Kullanacağım (BYOK)"
                          )
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-radio",
                    {
                      staticClass: "key-mode-option",
                      attrs: { value: "supsis", disabled: "" },
                    },
                    [
                      _c(
                        "span",
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t("message.supsisKeyTitle") ||
                                  "Supsis AI API Anahtarı Sağlasın"
                              ) +
                              "\n                        "
                          ),
                          _c("a-tag", { attrs: { color: "orange" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("chatbotv2.comingSoon") || "Yakında"
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.clone.payload.keyMode === "byok"
            ? _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("message.openrouterApiKey") ||
                          "OpenRouter API Key"
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("a-input-password", {
                    attrs: { placeholder: _vm.$t("message.openrouterApiKey") },
                    model: {
                      value: _vm.clone.payload.apiKey,
                      callback: function ($$v) {
                        _vm.$set(_vm.clone.payload, "apiKey", $$v)
                      },
                      expression: "clone.payload.apiKey",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "help-text" },
                    [
                      _c("a-icon", { attrs: { type: "info-circle" } }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$t("message.openrouterApiKeyHint") ||
                                "API anahtarınızı"
                            ) +
                            "\n                    "
                        ),
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "https://openrouter.ai/keys",
                              target: "_blank",
                            },
                          },
                          [_vm._v("OpenRouter Dashboard")]
                        ),
                        _vm._v(
                          "\n                    " +
                            _vm._s("üzerinden alabilirsiniz.") +
                            "\n                "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("message.status") || "Durum")),
              ]),
              _vm._v(" "),
              _c("a-switch", {
                model: {
                  value: _vm.clone.enabled,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "enabled", $$v)
                  },
                  expression: "clone.enabled",
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "status-text" }, [
                _vm._v(
                  _vm._s(
                    _vm.clone.enabled
                      ? _vm.$t("message.active")
                      : _vm.$t("message.inactive")
                  )
                ),
              ]),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "section" }, [
          _c("h3", [
            _vm._v(
              _vm._s(_vm.$t("message.providerInfo") || "Provider Bilgisi")
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "provider-info-card" }, [
            _c("img", {
              staticClass: "provider-logo",
              attrs: { src: _vm.providerLogo, alt: _vm.providerName },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "provider-details" }, [
              _c("div", { staticClass: "provider-name" }, [
                _vm._v(_vm._s(_vm.providerName)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "provider-slug" }, [
                _vm._v(_vm._s(_vm.clone.payload.provider)),
              ]),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }